<template>
  <section :class="['manufacturers', { 'manufacturers--cards': cards }]">
    <!-- Стиль «Manrope»: светлая шапка с картинкой и поиском, карточки брендов (макет владельца 12.10.2026) -->
    <div v-if="cards" class="mf-hero" :style="{ backgroundImage: `linear-gradient(90deg, #fff 0%, #fff 38%, rgba(255,255,255,.72) 62%, rgba(255,255,255,.25) 100%), url(${heroImg})` }">
      <div class="container mf-hero__inner">
        <div>
          <h1 class="mf-hero__title">Manufacturers</h1>
          <the-breadcrumbs></the-breadcrumbs>
        </div>
        <label class="mf-search">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="8.5" cy="8.5" r="6.5" stroke="#272930" stroke-width="2"/><path d="m13.5 13.5 4.5 4.5" stroke="#272930" stroke-width="2" stroke-linecap="round"/></svg>
          <input v-model="inputSearchValue" type="text" placeholder="Search in manufacturers..." aria-label="Search in manufacturers"/>
          <button v-if="isVisibleClearSearch" type="button" class="mf-search__clear" @click="inputSearchValue = ''" aria-label="Clear">×</button>
        </label>
      </div>
    </div>
    <div class="container">
      <div class="manufacturers__wrapper">
        <div v-if="!cards" class="manufacturers__wrapper-head">
          <div>
            <h2>Manufacturers</h2>
            <the-breadcrumbs></the-breadcrumbs>
          </div>
          <div class="manufacturers__wrapper-search">
            <svg
              class="manufacturers__wrapper-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="19"
              fill="none"
            >
              <path
                fill="#272930"
                d="M.001 7.48c0 4.142 3.404 7.479 7.629 7.479 4.224 0 7.628-3.337 7.628-7.48C15.258 3.337 11.855 0 7.63 0S0 3.337 0 7.48ZM7.63 2.876c2.581 0 4.694 2.07 4.694 4.602 0 2.532-2.113 4.603-4.694 4.603-2.582 0-4.695-2.071-4.695-4.603 0-2.531 2.113-4.602 4.695-4.602Z"
              />
              <path fill="#272930" d="m13.727 10.293 6.39 6.266-2.49 2.44-6.389-6.264 2.49-2.441Z" />
            </svg>
            <input v-model="inputSearchValue" type="text" placeholder="Search in list" />
            <button v-if="isVisibleClearSearch" @click="inputSearchValue = ''" class="manufacturers__wrapper-clear">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none">
                <path
                  fill="#272930"
                  d="M8.423.101a.337.337 0 0 0-.482 0L5 3.084 2.06.101a.337.337 0 0 0-.483 0L.1 1.6a.35.35 0 0 0 0 .489L2.97 5 .1 7.911a.35.35 0 0 0 0 .49l1.477 1.498a.337.337 0 0 0 .482 0L5 6.916l2.942 2.983a.337.337 0 0 0 .482 0L9.9 8.4a.35.35 0 0 0 0-.489L7.03 5 9.9 2.089a.35.35 0 0 0 0-.49L8.423.102Z"
                />
              </svg>
            </button>
          </div>
        </div>
        <!-- Бренды текстом или логотипами — админка → Сайт → Бренды и дисклеймеры -->
        <div :class="['manufacturers__block', { 'manufacturers__block--text brand-names--page': asText }]">
          <div :class="['manufacturers__card', { 'manufacturers__card--box': cards }]" v-for="item in dataManufacturers" :key="item.name">
            <router-link :to="{ name: 'manufacturer', params: { manufacturer: item.slug } }" :class="{hidden: (item.hidden ? item.hidden : false)}" class="block-overlay"></router-link>
            <span v-if="asText" :class="['brand-name', 'brand-name--' + textStyle, 'manufacturers__card-name']" v-html="brandName(item.name)"></span>
          </div>
        </div>
        <p v-if="cards && !dataManufacturers.length && inputSearchValue" class="mf-empty">No manufacturers found for “{{ inputSearchValue }}”.</p>
        <p v-if="asText && note" class="manufacturers__note">{{ note }}</p>
      </div>
    </div>
    <div class="mobile">
      <feedback-block></feedback-block>
    </div>
  </section>
  <modal-form v-if="isVisibleModalForm" @toggle-modal="toggleModalForm"></modal-form>
</template>

<script>
import ModalForm from "@/components/pages/productPage/ModalForm.vue";
import TheBreadcrumbs from "@/components/ui/TheBreadcrumbs.vue";
import FeedbackBlock from "@/components/pages/mainPage/feedback/FeedbackBlock.vue";
import { getManufacturers } from "@/functions/dataload";

import {useSiteSettings} from "@/functions/siteSettings";
import heroImg from "@/assets/images/hero-new.jpg";

export default {
  components: { TheBreadcrumbs, FeedbackBlock, ModalForm },
  setup() {
    return { catalog: useSiteSettings("catalog") };
  },
  computed: {
    isVisibleClearSearch() {
      return this.inputSearchValue;
    },
    asText() {
      return true; // только названия, логотипы брендов не используются
    },
    textStyle() {
      const s = this.catalog?.brandsPageStyle;
      return ["light", "bold", "spaced", "large", "accent", "manrope"].includes(s) ? s : "light";
    },
    note() {
      return (this.catalog?.brandsPageNote ?? "").trim();
    },
    cards() {
      return this.asText && this.textStyle === "manrope";
    },
  },
  data() {
    return {
      inputSearchValue: "",
      heroImg,
      isVisibleModalForm: false,
      dataManufacturersFullFist: [],
      dataManufacturers: [],
    };
  },
  methods: {
    /** Название бренда заглавными; после «+» разрешаем перенос строки. */
    brandName(name) {
      const esc = String(name ?? "").toUpperCase()
          .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return esc.replace(/\+/g, "+<wbr>");
    },
    getImgUrl(pic) {
      return "/assets/images/" + pic;
    },

    toggleModalForm() {
      this.isVisibleModalForm = !this.isVisibleModalForm;
      this.isVisibleModalForm
        ? document.body.classList.add("body-overlay")
        : document.body.classList.remove("body-overlay");
    },

    async loadData() {
      this.dataManufacturersFullFist = await getManufacturers();
      this.dataManufacturers = this.dataManufacturersFullFist;
    },


    filterManufacturers(filterStr) {
      this.dataManufacturers = this.dataManufacturersFullFist.filter(item=>item.name.toLowerCase().includes(filterStr.toLowerCase()));
    }
  },
  mounted() {
    this.loadData();
    window.scrollTo({
      top: 1,
      behavior: "smooth",
    });
  },
  watch: {
    inputSearchValue: function (value) {
      this.filterManufacturers(value);
    },
    $route(to, from) {
      this.loadData();
    }
  }
};
</script>

<style scoped>
.hidden {
  display: none;
}

.mobile {
  display: none;
}
.manufacturers__wrapper {
  padding-top: 60px;
  padding-bottom: 77px;
  min-height: 100vh;
}
.manufacturers__wrapper-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 77px;
}
.manufacturers__wrapper h2 {
  font-size: 46px;
  line-height: 100%;
  margin-bottom: 16px;
}
.manufacturers__wrapper-search {
  width: 334px;
  height: 60px;
  position: relative;
  padding-bottom: 20px;
}
.manufacturers__block {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}
.manufacturers__card {
  position: relative;
  height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #f4f4f5;
}
.manufacturers__block--text {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.manufacturers__card-name {
  padding: 0 12px;
}
.manufacturers__note {
  margin-top: 14px;
  font-size: 13px;
  line-height: 1.4;
  color: rgba(39, 41, 48, 0.45);
}
.manufacturers__card img {
  width: 140px;
  height: 50px;
  object-fit: cover;
}
.manufacturers__wrapper-search input {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  font-size: 16px;
  line-height: 100%;
  padding-left: 30px;
  border-bottom: 2px solid rgba(39, 41, 48, 0.5);
  transition: 0.5s ease;
}
.manufacturers__wrapper-search input:focus {
  border-bottom: 2px solid #6083c0;
  transition: 0.5s ease;
}
.manufacturers__wrapper-svg,
.manufacturers__wrapper-clear {
  position: absolute;
}
.manufacturers__wrapper-svg {
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.manufacturers__wrapper-clear {
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.manufacturers__wrapper-clear svg {
  opacity: 0.5;
}
@media (max-width: 1199px) {
  .manufacturers__card {
    height: 220px;
  }
  .manufacturers__card img {
    width: 100px;
    height: 35px;
  }
}
@media (max-width: 990px) {
  .manufacturers__card img {
    width: 80px;
    height: 15px;
  }
  .manufacturers__card {
    height: 150px;
  }
}
@media (max-width: 767px) {
  .mobile {
    display: block;
  }
  .manufacturers__wrapper-search {
    width: 284px;
  }
  .manufacturers__wrapper-svg {
    transform: translateY(-45%) scale(0.88);
  }
  .manufacturers__wrapper-search input {
    height: 53px;
    font-size: 14px;
    line-height: 100%;
  }
  .manufacturers__wrapper-head {
    margin-bottom: 27px;
  }
  .manufacturers__wrapper {
    padding-top: 36px;
    padding-bottom: 48px;
  }
  .manufacturers__wrapper h2 {
    font-size: 26px;
    line-height: 100%;
    margin-bottom: 12px;
  }
  .manufacturers__wrapper-head {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .manufacturers__card img {
    width: 60px;
    height: 18px;
  }
  .manufacturers__block,
  .manufacturers__block--text {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .manufacturers__card-name {
    padding: 0 6px;
  }
  .manufacturers__card {
    height: 110px;
  }
}
/* ===== Стиль «Manrope»: шапка и карточки ===== */
.mf-hero {
  background-color: #f4f7fb;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right 10%;
  border-bottom: 1px solid #e8edf3;
}
.mf-hero__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding-top: 44px;
  padding-bottom: 40px;
}
.mf-hero__title {
  font-size: 46px;
  line-height: 100%;
  margin-bottom: 16px;
}
.mf-search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 360px;
  max-width: 100%;
  height: 52px;
  padding: 0 16px;
  background: #fff;
  border: 1px solid #e3e7ee;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(11, 36, 84, 0.06);
  cursor: text;
}
.mf-search input {
  flex: 1;
  min-width: 0;
  height: 100%;
  border: none;
  background: transparent;
  font-size: 15px;
  color: #0b2454;
}
.mf-search input:focus {
  outline: none;
}
.mf-search:focus-within {
  border-color: #6083c0;
}
.mf-search__clear {
  border: none;
  background: none;
  font-size: 20px;
  line-height: 1;
  color: rgba(11, 36, 84, 0.5);
  cursor: pointer;
}
.manufacturers--cards .manufacturers__wrapper {
  padding-top: 40px;
  min-height: 0;
}
.manufacturers--cards .manufacturers__block--text {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
}
.manufacturers__card--box {
  height: 112px;
  align-items: flex-start;
  justify-content: center;
  padding: 0 20px;
  border: 1px solid #e3e7ee;
  border-radius: 6px;
  background: #fff;
  transition: background-color 0.25s ease, box-shadow 0.25s ease;
}
.manufacturers__card--box:hover {
  background-color: #f1fafc;
  box-shadow: 0 8px 22px rgba(11, 36, 84, 0.06);
}
.manufacturers__card--box .manufacturers__card-name {
  padding: 0;
  text-align: left;
}
.manufacturers__card--box .brand-name--manrope {
  font-size: 16px;
}
.manufacturers__card--box .brand-name--manrope::after {
  margin: 10px 0 0;
  width: 32px;
  border-radius: 2px;
}
.mf-empty {
  padding: 30px 0;
  color: rgba(11, 36, 84, 0.6);
  font-size: 16px;
}
.manufacturers--cards .manufacturers__note {
  margin-top: 40px;
  padding-top: 22px;
  border-top: 1px solid #e3e7ee;
  max-width: 980px;
  font-size: 13px;
  line-height: 1.6;
  color: rgba(39, 41, 48, 0.55);
}
@media (max-width: 1199px) {
  .manufacturers--cards .manufacturers__block--text {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .manufacturers__card--box {
    height: 104px;
  }
}
@media (max-width: 767px) {
  .mf-hero {
    background-position: 70% 10%;
  }
  .mf-hero__inner {
    flex-direction: column;
    align-items: stretch;
    padding-top: 28px;
    padding-bottom: 24px;
    gap: 18px;
  }
  .mf-hero__title {
    font-size: 26px;
    margin-bottom: 12px;
  }
  .mf-search {
    width: 100%;
    height: 48px;
  }
  .manufacturers--cards .manufacturers__wrapper {
    padding-top: 22px;
  }
  .manufacturers--cards .manufacturers__block--text {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .manufacturers__card--box {
    height: 84px;
    padding: 0 14px;
  }
  .manufacturers__card--box .brand-name--manrope {
    font-size: 14px;
  }
  .manufacturers--cards .manufacturers__note {
    margin-top: 28px;
    font-size: 12px;
  }
}
</style>